import { Link } from "react-router-dom";
import { LogOut, Settings, Store, Package, SunMoon } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/contexts/AuthContext";
import { useSettings } from "@/contexts/SettingsContext";
export default function UserMenu({
  onAuthClick,
}: {
  onAuthClick: (mode?: "login" | "signup") => void;
}) {
  const { user, signOut } = useAuth();
  const { avatar } = useSettings();
  if (!user)
    return (
      <div className="flex items-center gap-2">
        <Link to="/plans" className="inline-flex min-h-11 items-center px-2 text-sm font-semibold">Plans</Link>
        <Button size="sm" onClick={() => onAuthClick("login")}>Log In</Button>
      </div>
    );
  const name = user.user_metadata?.full_name || user.email || "Collector";
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          aria-label="Profile and settings"
          variant="ghost"
          className="min-h-11 min-w-11 rounded-full p-1"
        >
          <Avatar className="h-9 w-9">
            <AvatarImage
              src={user.user_metadata?.avatar_url || ""}
              alt={name}
            />
            <AvatarFallback className="bg-holo-blue/20 text-foreground">
              {avatar || name[0]}
            </AvatarFallback>
          </Avatar>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-64">
        <p className="truncate px-2 py-3 text-sm font-bold">{name}</p>
        <DropdownMenuItem asChild><Link to="/plans"><Settings className="mr-2 h-4 w-4" />Plans & billing</Link></DropdownMenuItem>
        <DropdownMenuItem asChild>
          <Link to="/profile">
            <Settings className="mr-2 h-4 w-4" />
            Profile & Settings
          </Link>
        </DropdownMenuItem>
        <DropdownMenuItem asChild>
          <Link to="/profile#appearance">
            <SunMoon className="mr-2 h-4 w-4" />
            Appearance
          </Link>
        </DropdownMenuItem>
        <DropdownMenuItem asChild>
          <Link to="/profile#alerts">
            <Settings className="mr-2 h-4 w-4" />
            Alert preferences
          </Link>
        </DropdownMenuItem>
        <DropdownMenuItem asChild>
          <Link to="/purchases">
            <Package className="mr-2 h-4 w-4" />
            My purchases
          </Link>
        </DropdownMenuItem>
        <DropdownMenuItem asChild>
          <Link to="/seller">
            <Store className="mr-2 h-4 w-4" />
            Seller workspace
          </Link>
        </DropdownMenuItem>
        <DropdownMenuItem onClick={() => void signOut()}>
          <LogOut className="mr-2 h-4 w-4" />
          Log out
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}

